<template>
    <el-container class="healthy page-x" direction="vertical">
        <div class="search-x">
            <div class="search-item">
                <span class="label">权益人信息</span>
                <el-input class="input-box" clearable placeholder="权益人用户ID、姓名" v-model.trim="searchBox.rightsUserInfo">
                </el-input>
            </div>
            <div class="search-item">
                <span class="label">订单号</span>
                <el-input class="input-box" clearable placeholder="订单号" v-model.trim="searchBox.orderNo"></el-input>
            </div>
            <div class="search-item">
                <span class="label">服务项目名称</span>
                <select-all v-model="searchBox.itemIds"
                    placeholder="服务项目名称"
                    :data="serviceList"
                    :option="{label: 'itemName', value: 'id'}">
                </select-all>
            </div>
            <div class="search-item">
                <span class="label">供应商</span>
                <select-all v-model="searchBox.providerIds"
                    :data="supplierList"
                    :option="{label: 'providerName', value: 'id'}">
                </select-all>
            </div>

            <div class="search-item">
                <span class="label">咨询人信息</span>
                <el-input class="input-box" clearable placeholder="咨询人姓名、手机号、证件号"
                    v-model.trim="searchBox.treatmentUserInfo"></el-input>
            </div>
            <div class="search-item">
                <span class="label">服务单号</span>
                <el-input class="input-box" clearable placeholder="服务单号" v-model.trim="searchBox.serviceNo"></el-input>
            </div>
            <div class="search-item">
                <span class="label">咨询时间</span>
                <el-date-picker v-model="timeCache.treatmentTime" @change="
                    (e) =>
                        toChangeTime(
                            e,
                            'treatmentBeginTime',
                            'treatmentEndTime'
                        )
                " type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    :picker-options="{
                        disabledDate(time) {
                            return time.getTime() > Date.now();
                        },
                    }">
                </el-date-picker>
            </div>
            <el-button v-auth="'sa_order_page'" type="primary" @click="toSearch">查询</el-button>
            <el-button v-auth="'sa_order_page'" type="primary" @click="() => ($root.showPage = false)">重置</el-button>
            <el-button v-auth="'sa_order_export'" type="warning" @click="toExport">导出数据</el-button>
        </div>
        <div class="cont-x">
            <div class="table-x" ref="tableBox">
                <el-table v-loading="loading" :data="tableData" :height="tableHeight" border class="mb20">
                    <el-table-column prop="orderNo" align="center" label="序号">
                        <template slot-scope="scope">
                            {{
                                    (searchBox.pageNo - 1) * searchBox.pageSize +
                                    scope.$index +
                                    1
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderNo" align="center" label="订单号" width="200"></el-table-column>
                    <el-table-column prop="serviceNo" align="center" width="160" label="服务单号"></el-table-column>
                    <el-table-column prop="productName" align="center" width="160" label="服务项目名称"></el-table-column>
                    <el-table-column prop="name" align="center" width="160" label="咨询人姓名"></el-table-column>
                    <el-table-column align="center" width="160" label="咨询人证件类型">
                        <template slot-scope="scoped">
                            <span>{{
                                cardType[scoped.row.cardType] || scoped.row.cardType
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cardNo" align="center" width="160" label="咨询人证件号"></el-table-column>
                    <el-table-column prop="mobile" align="center" width="160" label="手机号"></el-table-column>
                    <el-table-column prop="rightsUserId" align="center" width="160" label="权益用户ID">
                        <template slot-scope="scoped">
                            <span>{{ scoped.row.rightsUserId ? scoped.row.rightsUserId : "--" }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="rightsUserName" align="center" width="160" label="权益人姓名"></el-table-column>
                    <el-table-column prop="relation" align="center" label="与权益人关系" width="160">
                        <template slot-scope="scoped">
                            <span>{{
                                    relation[scoped.row.relation] || scoped.row.relation
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="consultTime" align="center" width="160" label="咨询时间"></el-table-column>
                    <el-table-column prop="providerName" align="center" width="160" label="供应商"></el-table-column>
                    <el-table-column prop="printNo" align="center" width="160" label="操作">
                        <template slot-scope="scope">
                            <el-button size="middle" class="mb10" type="text" @click="showDetail(scope.row.id)">查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="pagenation-x">
            <div class="pagination mb20">
                <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-sizes="[10,50,100]" :current-page="searchBox.pageNo"
                    :page-size.sync="searchBox.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
                    background>
                </el-pagination>
            </div>
        </div>
        <drag-dialog title="电话医生服务详情" v-model="dialogVisible">
            <div class="dialog-list">
                <div class="title">基本信息</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">姓名：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">手机号：</div>
                    <div class="dialog-list-text">{{ dialogData.mobile }}</div>
                </div>
                <div class="title">咨询记录</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">咨询时间：</div>
                    <div class="dialog-list-text">{{ dialogData.consultTime }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">咨询分类：</div>
                    <div class="dialog-list-text">{{ dialogData.consultType }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">分科：</div>
                    <div class="dialog-list-text">{{ dialogData.department }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">主诉：</div>
                    <div class="dialog-list-text">{{ dialogData.demand }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">预评估：</div>
                    <div class="dialog-list-text">{{ dialogData.preEvaluation }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">总结：</div>
                    <div class="dialog-list-text">{{ dialogData.doctorConclusion }}</div>
                </div>
                <div class="title">服务评价</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">用户评价：</div>
                    <div class="dialog-list-text">{{ dialogData.userEvaluation }}</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">返回</el-button>
            </span>
        </drag-dialog>
    </el-container>
</template>

<script>
import dragDialog from "@/components/health/dragDialog.vue";
import { cardType, orderState, relation } from "@/assets/js/options";
import { dateFormat } from "@/assets/js/until.js";
import SelectAll from "@/components/SelectAll";
export default {
    name: "healthy",
    components: {
        dragDialog,
        SelectAll
    },
    data() {
        return {
            cardType, // 证件类型list
            orderState, // 订单状态list
            relation, // 与权益人关系list
            tableHeight: 0, // 表格高度
            // table表格
            loading: false,
            tableData: [], // table数据
            total: 0,
            // 查询条件
            timeCache: {}, // 时间缓存
            supplierList: [], // 供应商列表
            serviceList: [], // 服务项目名称列表
            statusArr: [],
            searchBox: {
                pageSize: 10,
                pageNo: 1,
            }, // 搜索条件
            // 弹窗
            dialogVisible: false, // 弹窗visible
            dialogData: {}, // 弹窗中的数据
        };
    },
    created() {
        // 面包导航
        this.$root.breadList = [
            { name: "服务订单", link: "" },
            { name: "电话医生订单", link: "" },
        ];
    },
    mounted() {
        this.getServiceList();
        this.getSupplierList();
        this.$nextTick(()=>{
            this.listenWindow()
            this.getData()
        })
    },
    methods: {
        //窗口改变，重新取得高度
        listenWindow() {
            this.tableHeight = this.$refs.tableBox.offsetHeight;
            window.addEventListener('resize', ()=>{
                clearTimeout(this.resizeFlag)
                                    this.resizeFlag = setTimeout(() => {
                    try {
                        this.tableHeight = this.$refs.tableBox.offsetHeight;
                    } catch (error) {}
                }, 300);
            })
        },
        /**
         * 获取服务项目列表
         */
        async getServiceList() {
            let res = await this.axios.get(this.getApiUrl("callDoctorOrderItemList"), {
                params: {},
            });
            this.serviceList = res?.data || [];
        },
        /**
         * 获取供应商列表
         */
        async getSupplierList() {
            let res = await this.axios.get(this.getApiUrl("callDoctorOrderProviderList"), {
                params: {},
            });
            this.supplierList = res?.data|| [];
        },
        /**
         * 显示弹窗
         */
        async showDetail(id) {
            // 清空状态
            this.dialogData = {}
            this.historicalTrack = []
            this.dialogVisible = true;
            // 请求
            let res = await this.axios.get(this.getApiUrl("callDoctorOrderInfo"), {
                params: { id },
            });
            this.dialogData = res?.data || {};
            console.log(this.dialogData)
        },
        /**
         * 搜索按钮
         */
        toSearch() {
            this.searchBox.pageNo = 1;
            this.getData();
        },
        /**
         * 导出数据
         */
        async toExport() {
            var params = { ...this.searchBox }
            Object.keys(params).forEach((key) => {
                if (Object.prototype.toString.call(params[key]) === "[object Array]") {
                    params[key] = params[key].length == 1 ? params[key][0] : params[key].join(",");
                }
                if (params[key] === '' || params[key] === undefined || params[key] === null) delete params[key] // 请求时删除冗余字段
            })
            delete params.pageNo;
            delete params.pageSize;
            let urlPath = this.getApiUrl("callDoctorOrderExport")
            this.$root.exportFile(urlPath, params, "电话医生导出")
        },
        /**
         * 获取数据
         */
        async getData() {
            var params = { ...this.searchBox }
            Object.keys(params).forEach((key) => {
                if (Object.prototype.toString.call(params[key]) === "[object Array]") {
                    params[key] = params[key].length == 1 ? params[key][0] : params[key].join(",");
                }
                if (params[key] === '' || params[key] === undefined || params[key] === null) delete params[key] // 请求时删除冗余字段
            })
            const res = await this.axios
                .get(this.getApiUrl('callDoctorOrderPage'), {
                    params
                })
            console.log("获取数据", res);
            if (res.data) {
                this.tableData = res.data.data;
                this.total = res.data.total
            }
        },
        /**
         * 换页
         */
        handleCurrentChange(val) {
            this.searchBox.pageNo = val;
            this.getData();
        },
        handleSizeChange( val ){
            this.searchBox.pageNo = 1;
            this.searchBox.pageSize = val;
            this.getData();
        },
        /**
         * 时间回调函数
         */
        toChangeTime(val, startName, endName) {
            console.log(val);
            if (val && val.length) {
                this.searchBox[startName] = dateFormat(val[0]);
                this.searchBox[endName] = dateFormat(val[1]);
            } else {
                this.searchBox[startName] = "";
                this.searchBox[endName] = "";
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/color.scss";

.dialog-list {
    .title {
        height: 30px;
        line-height: 30px;
        margin-bottom: 20px;
        font-weight: bold;
        padding-left: 20px;
        margin-top: 18px;
        position: relative;

        &::before {
            content: "";
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 8px;
            background-color: $theme;
        }
    }

    .dialog-list-box {
        padding-bottom: 10px;
        display: flex;

        .dialog-list-title {
            padding-left: 20px;
            width: 80px;
            white-space: nowrap;
            text-align: right;
        }

        .dialog-list-text {
            flex: 1;
        }
    }
}
.cont-x {
    flex: 1;
    flex-shrink: 0;
    .table-x {
        height: 100%;
    }
}
</style>